import React from 'react';
import PropTypes from 'prop-types';
import { observableArrayProp } from 'core/utils';
import { BaasicTableTemplate } from 'themes/components';
import { isSome } from 'core/utils';

function BaasicTableKendo(props) {
	const { queryUtility, tableData, data, columns, ...otherProps } = props;
	return (
		<BaasicTableTemplate
			{...otherProps}
			{...{ tableData, data }}
			queryUtility={queryUtility || false}
			columns={tableData.columns}
			sort={tableData.sortObject}
			sortable={isSome(tableData.sortObject)}
			onPageChange={evt => queryUtility.handlePageChangeEvt(evt)}
			take={(queryUtility && queryUtility.filter.pageSize) || (data && data.length)}
			skip={(queryUtility && (queryUtility.filter.pageNumber - 1) * queryUtility.filter.pageSize) || 0}
			total={(queryUtility && queryUtility.recordCount) || (data && data.length)}
			pageable={queryUtility && queryUtility.recordCount > 0 ? queryUtility.pageableObject : false}
			onExpandChange={otherProps.expandChange}
			resizable={true}
		/>
	);
}

BaasicTableKendo.propTypes = {
	onRowClick: PropTypes.func,
	expandChange: PropTypes.func,
	onPageChange: PropTypes.func,
	onSortChange: PropTypes.func,
	edit: PropTypes.func,
	update: PropTypes.func,
	cancel: PropTypes.func,
	onItemChange: PropTypes.func,
	allowEdit: PropTypes.bool,
	removeRow: PropTypes.func,
	onSelectAllHeaderClick: PropTypes.func,
	onCheckboxChange: PropTypes.func,
	remove: PropTypes.func,
	cell: PropTypes.array || PropTypes.func,
	columns: PropTypes.arrayOf(PropTypes.object),
	sortObject: PropTypes.arrayOf(
		PropTypes.shape({
			field: PropTypes.string,
			dir: PropTypes.string,
		})
	),
	data: function(props, propName, componentName) {
		if (!props[propName] && props.listStore[propName] && props.listStore[propName].length > 0) {
			return observableArrayProp(props.listStore, propName, componentName);
		}
	},
	tableData: PropTypes.shape({
		columns: PropTypes.arrayOf(PropTypes.object),
		sortObject: PropTypes.arrayOf(
			PropTypes.shape({
				field: PropTypes.string,
				dir: PropTypes.string,
			})
		),
		onRowClick: PropTypes.func,
	}),
	queryUtility: PropTypes.shape({
		changeOrder: PropTypes.func,
		changePageSize: PropTypes.func,
	}),
	showSelectAllColumn: PropTypes.bool,
	groupable: PropTypes.bool,
	noDataItem: PropTypes.bool,
	editField: PropTypes.string,
};

export default BaasicTableKendo;
